import { useCallback, useState } from "react";
import { formatDateDash } from "../utils/helpers";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export default function useValidateForm() {
  const [isValidGenders, setIsValidGenders] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [isConsistency, setIsConsistency] = useState(true);
  const [isValidTextInput, setIsValidTextInput] = useState(true);
  const [isBirthdayValid, setIsBirthDayValid] = useState({
    validFormat: true,
    validAge: true,
  });
  const [comparableText, setComparableText] = useState("");
  const [comparableIsEmpty, setComparableIsEmpty] = useState(false);

  // new Date(new Date().getTime() - 567993600000

  const validateTextInput = (text) => {
    setIsValidTextInput(text.length > 0);
  };
  const formatDate = (date) => {
    if (!date) return "";
    const receivedDate = `${date?.$D >= 10 ? "" : "0"}${date?.$D}/${
      date?.$M + 1 >= 10 ? "" : "0"
    }${date?.$M + 1}/${date?.$y}`;
    return formatDateDash(receivedDate);
  };
  const onComparableTextHandle = useCallback(
    (event) => {
      setComparableText(event.target.value);
    },
    [comparableText]
  );

  const getValidGenders = (validGender) => {
    setIsValidGenders(validGender);
  };

  const checkConsistency = (firstVal, secVal) => {
    if (!secVal.length) {
      setComparableIsEmpty(false);
    }
    setIsConsistency(firstVal === secVal);
  };

  const validateEmail = (email) => {
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(regexEmail.test(email));
  };
  const validateDifficultyPassword = (password) => {
    setIsValidPassword(password.length >= 6);
  };

  const parseFlexibleDate = (str) => {
    if (!str) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      const d = dayjs(str);
      return d.isValid() ? d : null;
    }

    if (/^\d{2}\.\d{2}\.\d{4}$/.test(str)) {
      const d = dayjs(str, "DD.MM.YYYY", true); // strict mode
      return d.isValid() ? d : null;
    }

    // EN-локаль: MUI-поле показывает MM/DD/YYYY, и при повторном сабмите
    // в валидатор попадает сырая строка из DOM — без этой ветки
    // "02/23/1975" считалась невалидной и блокировала регистрацию
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
      const d = dayjs(str, ["MM/DD/YYYY", "DD/MM/YYYY"], true);
      return d.isValid() ? d : null;
    }

    return null;
  };

  const validateBirthday = (birthday) => {
    const parsed = parseFlexibleDate(birthday);
    const today = dayjs();

    const isAgeValid = parsed ? today.diff(parsed, "year") >= 18 : false;

    setIsBirthDayValid({
      validFormat: !!parsed,
      validAge: isAgeValid,
    });
  };

  const manageValidate = (name, value) => {
    switch (name) {
      case "email":
        validateEmail(value);
        break;
      case "password":
        validateDifficultyPassword(value);
        break;
      default:
        break;
    }
  };

  return {
    getValidGenders,
    validateDifficultyPassword,
    onComparableTextHandle,
    formatDate,
    checkConsistency,
    validateBirthday,
    setComparableIsEmpty,
    comparableIsEmpty,
    isValidEmail,
    isValidPassword,
    isConsistency,
    isValidGenders,
    comparableText,
    isBirthdayValid,
    validateEmail,
    isValidTextInput,
    validateTextInput,
    manageValidate,
    setIsValidEmail,
    setIsValidPassword,
    setIsConsistency,
  };
}
